export const eValues = {
  ا: 1, أ: 1, إ: 1, آ: 1, ب: 2, ج: 3, د: 4, ه: 5, و: 6, ؤ: 6, ز: 7, ح: 8, ط: 9,
  ي: 10, ئ: 10, ی: 10, ك: 11, ل: 12, م: 13, ن: 14, س: 15, ع: 16, ف: 17, ص: 18,
  ق: 19, ر: 20, ش: 21, ت: 22, ث: 23, خ: 24, ذ: 25, ض: 26, ظ: 27, غ: 28,
  لا: 13, 'ِ': 0, 'َ': 0, 'ُ': 0, 'ً': 0, 'ٍ': 0, 'ٌ': 0, 'ْ': 0, 'ّ': 0, ء: 1
};


// WEBPACK FOOTER //
// ./src/abjad-keys/earthly.js